import { useEffect, useState } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Dashboard from "./dashboard/Index";
import CompanyDetails from "../customer/companies/Index";
import {
  LicenseTypes,
  MapPageFor,
  PageFor,
  PageFrom,
  PageFromJunction,
} from "../../../utils/Enum.types";

import EmailConfig from "./settings/emailConfig";
import ItemOBList from "./item/item_ob/List";
import ItemIndividualList from "./item/item_individual/List";
import ItemsList from "./item/ItemsList";

import CompanyRoutes from "../customer/companies/CompanyRoutes";
import DashBoard from "../../common/layout/Index";

import DashBoardIndex from "./DashBoardMapsView/DashboardIndex";
import BillBookConfig from "./settings/BillBookConfig";
import AssetConfiguration from "./configurations/AssetConfiguration";
import { SwConfigQueryType } from "./masters/items/configurations/queries/type";
import ReportsIndex from "./reports/assetwise/ReportsIndex";
import VendorWiseIndex from "./reports/vendorwise/VendorWiseIndex";
import TicketWiseIndex from "./reports/ticketwise/TicketWiseIndex";
import Mainpage from "./DashBoardMapsView/dashboardcomponents/Mainpage";
import VendorWiseItemDetails from "./reports/vendorwise/ItemDetails";
import { TicketsQueryType } from "../../../queries/types";
import SignalWiseIndex from "./reports/signalwise/SignalWiseIndex";

import {
  WINDOW_MAX_ZOOM,
  WINDOW_MIN_HEIGHT,
  WINDOW_MIN_WIDTH,
} from "../../../utils/constants";
import Projects from "./Meetings/Projects";
import AttendanceList from "./Meetings/AttendanceList";
import ViewMeetingDetails from "./Meetings/ViewMeetingDetails";
import PlanForProjects from "./Meetings/planning/PlanForProjects";
import Meetings from "./Meetings/Meetings";
import CalibrationDetails from "./calibration/CalibrationDetails";
import WorkProgress from "./work_progress/WorkProgress";
import ViewProjectDetails from "./work_progress/projectdetails/View";
import TableStructure from "./work_progress/masters/TableStructure";
import ViewTableStructure from "./work_progress/masters/ViewTableStructure";
import CaseStudy from "./casestudy/CaseStudy";
import ProjectDetails from "./masters/projects";
import Junctions from "./masters/subsidary/junctions/List";
import ViewJunctions from "./masters/subsidary/junctions/viewjunctions";
import BannerConfig from "./DashBoardMapsView/dashboardcomponents/BannerConfig";
import JunctionsItemList from "./masters/subsidary/junctions/JunctionsItemList";
import JunctionsItemReplacedList from "./masters/subsidary/junctions/JunctionsItemReplacedList";
import JunctionItemConutList from "./masters/subsidary/junctions/JunctionItemConutList";

const AssetRoutes = () => {
  const [modalFlag, setModalFlag] = useState(false);
  const [showWarning, setShowWarning] = useState(false);
  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });
  const [showError, setShowError] = useState(false);
  useEffect(() => {
    const handleResize = () => {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    let tolerance = 1;
    if (window.devicePixelRatio > 1) {
      tolerance = 1 / window.devicePixelRatio;
    }

    if (
      window.innerWidth < WINDOW_MIN_WIDTH * tolerance ||
      window.innerHeight < WINDOW_MIN_HEIGHT * tolerance
    ) {
      setShowError(true);
    } else {
      setShowError(false);
    }
  }, [windowSize]);

  useEffect(() => {
    if (window.devicePixelRatio > WINDOW_MAX_ZOOM) {
      setShowWarning(true);
    } else {
      setShowWarning(false);
    }
  }, [windowSize]);
  return (
    <div className="h100">
      {showError ? (
        <div className="error-overlay">
          <p>
            Your window size is too small. Please resize your browser to a
            larger window.
          </p>
        </div>
      ) : showWarning ? (
        <div className="warning-overlay">
          <p>
            Your browser zoom level is too high. Please adjust your zoom
            settings for optimal experience.
          </p>
        </div>
      ) : (
        <Router>
          <DashBoard>
            <Routes>
              <Route
                path="/:customerId/*"
                element={
                  <>
                    <Routes>
                      <Route
                        path="/dashboard/*"
                        element={
                          <Routes>
                            <Route path="/" element={<Mainpage />} />
                            <Route
                              path="/master/junctionreplace/*"
                              element={
                                <Routes>
                                  <Route
                                    path="/"
                                    element={
                                      <Junctions
                                        pageType={PageFor.GENERAL}
                                        setModalFlag={setModalFlag}
                                        pageForm={
                                          PageFromJunction.JUNCTION_ITEM_REPALCE_PAGE
                                        }
                                      />
                                    }
                                  />

                                  <Route
                                    path="/:junctionID/itemcountlist"
                                    element={<JunctionItemConutList NavType={LicenseTypes.TECHNICIAN_DASHBOARD}/>}
                                  />
                                  <Route
                                    path="/:junctionID/itemcountlist/:itemId/itemslist"
                                    element={
                                      <JunctionsItemList
                                        pageType={PageFor.GENERAL}
                                        NavType={
                                          LicenseTypes.TECHNICIAN_DASHBOARD
                                        }
                                        setModalFlag={setModalFlag}
                                      />
                                    }
                                  />
                                </Routes>
                              }
                            />
                            <Route
                              path="/master/componentreport"
                              element={
                                <JunctionsItemReplacedList
                                  pageType={PageFor.GENERAL}
                                  NavType={LicenseTypes.TECHNICIAN_DASHBOARD}
                                  setModalFlag={setModalFlag}
                                />
                              }
                            />
                          </Routes>
                        }
                      />
                      <Route path="/banner" element={<BannerConfig />} />
                      <Route
                        path="/reports/*"
                        element={
                          <>
                            <Routes>
                              <Route
                                path="/assetsummary/:itemId"
                                element={
                                  <ReportsIndex pageFrom={PageFrom.REPORTS} />
                                }
                              />
                              <Route
                                path="/vendorwise/:supplier_id"
                                element={<VendorWiseIndex />}
                              />
                              <Route
                                path="/signalwise/:supplier_id"
                                element={<SignalWiseIndex />}
                              />

                              <Route
                                path="/ticketwise"
                                element={
                                  <TicketWiseIndex
                                    queryType={TicketsQueryType.ALL}
                                  />
                                }
                              />

                              <Route
                                path="/componentreport"
                                element={
                                  <JunctionsItemReplacedList
                                    pageType={PageFor.GENERAL}
                                    NavType={LicenseTypes.DASHBOARD}
                                    setModalFlag={setModalFlag}
                                  />
                                }
                              />
                              <Route
                                path="/slawise"
                                element={
                                  <TicketWiseIndex
                                    queryType={TicketsQueryType.SLA_REPORT}
                                  />
                                }
                              />
                            </Routes>
                          </>
                        }
                      />
                      <Route
                        path="/ticketing"
                        element={
                          <DashBoardIndex
                            NavType={LicenseTypes.NONE}
                            pageFor={MapPageFor.TICKET}
                          />
                        }
                      />
                      {/* <Route
                        path="/vmsboards"
                        element={<VMSBoardsIndex NavType={LicenseTypes.NONE} />}
                      /> */}
                      {/* <Route
                        path="/tickets"
                        element={<DashbordTicketsDetails />}
                      /> */}

                      <Route path="/billbook" element={<BillBookConfig />} />
                      <Route
                        path="/configurations"
                        element={
                          <AssetConfiguration
                            queryType={SwConfigQueryType.ALL_CONFIGS}
                            pageType={PageFor.GENERAL}
                          />
                        }
                      />
                      <Route
                        path="/emailconfig"
                        element={
                          <EmailConfig
                            type={PageFor.GENERAL}
                            setModal={setModalFlag}
                          />
                        }
                      />
                      <Route
                        path="minutesofmeeting/*"
                        element={
                          <>
                            <Routes>
                              <Route path="/meetings" element={<Meetings />} />
                              <Route
                                path="/:momId/*"
                                element={
                                  <Routes>
                                    <Route path="/" element={<Projects />} />
                                    <Route
                                      path="/project/:projectId/*"
                                      element={
                                        <Routes>
                                          <Route
                                            path="/discussedplan"
                                            element={
                                              <PlanForProjects
                                                discussed={true}
                                              />
                                            }
                                          />
                                          <Route
                                            path="/notdiscussedplan"
                                            element={
                                              <PlanForProjects
                                                discussed={false}
                                              />
                                            }
                                          />
                                          <Route
                                            path="/respond"
                                            element={
                                              <PlanForProjects
                                                discussed={false}
                                              />
                                            }
                                          />
                                          <Route
                                            path="/viewmeetingdetails"
                                            element={
                                              <ViewMeetingDetails
                                                discussed={false}
                                              />
                                            }
                                          />
                                          <Route
                                            path="/viediscussedmeetingdetails"
                                            element={
                                              <ViewMeetingDetails
                                                discussed={true}
                                              />
                                            }
                                          />
                                        </Routes>
                                      }
                                    />
                                    <Route
                                      path="/attendance"
                                      element={
                                        <AttendanceList
                                          pageType={PageFor.GENERAL}
                                          setModalFlag={setModalFlag}
                                          date=""
                                          latest={true}
                                        />
                                      }
                                    />
                                  </Routes>
                                }
                              />
                            </Routes>
                          </>
                        }
                      />
                      <Route
                        path="/calibration"
                        element={<CalibrationDetails />}
                      />
                      <Route
                        path="/junctions/*"
                        element={
                          <Routes>
                            <Route
                              path="/"
                              element={
                                <Junctions
                                  setModalFlag={setModalFlag}
                                  pageType={PageFor.GENERAL}
                                />
                              }
                            />
                            <Route
                              path="/changepriority"
                              element={<ViewJunctions />}
                            />
                          </Routes>
                        }
                      />
                      <Route
                        path="/projectheaders/*"
                        element={
                          <>
                            <Routes>
                              <Route path="/" element={<TableStructure />} />
                              <Route
                                path="/:projectId/*"
                                element={
                                  <>
                                    <Routes>
                                      <Route
                                        path="/masters"
                                        element={
                                          <ViewTableStructure
                                            pageType={PageFor.GENERAL}
                                            setModal={setModalFlag}
                                          />
                                        }
                                      />
                                    </Routes>
                                  </>
                                }
                              />
                              <Route
                                path="/view"
                                element={<ViewProjectDetails />}
                              />
                            </Routes>
                          </>
                        }
                      />
                      <Route
                        path="/assetsummary/:itemId"
                        element={<ReportsIndex pageFrom={PageFrom.ADDSITE} />}
                      />
                      <Route
                        path="/projectdetails/*"
                        element={
                          <Routes>
                            <Route
                              path="/"
                              element={
                                <ProjectDetails
                                  pageType={PageFor.GENERAL}
                                  setModalFlag={setModalFlag}
                                />
                              }
                            />
                          </Routes>
                        }
                      />

                      <Route
                        path="/workprogress/*"
                        element={
                          <>
                            <Routes>
                              <Route
                                path="/"
                                element={
                                  <WorkProgress
                                    pageFrom={PageFrom.WORKPROGRESS}
                                  />
                                }
                              />
                              <Route
                                path="/:projectId/*"
                                element={
                                  <Routes>
                                    <Route
                                      path="/view"
                                      element={<ViewProjectDetails />}
                                    />
                                  </Routes>
                                }
                              />
                            </Routes>
                          </>
                        }
                      />
                      <Route
                        path="/casestudy/*"
                        element={
                          <Routes>
                            <Route path="/" element={<CaseStudy />} />
                          </Routes>
                        }
                      />
                    </Routes>
                  </>
                }
              />
              <Route
                path="/assets/*"
                element={
                  <Routes>
                    <Route path="/" element={<Dashboard />} />

                    <Route
                      path="/item/:customerId/*"
                      element={
                        <Routes>
                          <Route
                            path="/list"
                            element={
                              <ItemsList
                                NavType={LicenseTypes.ASSET}
                                setModalFlag={setModalFlag}
                                pageType={PageFor.GENERAL}
                              />
                            }
                          />
                          <Route
                            path="ob/list"
                            element={
                              <ItemOBList NavType={LicenseTypes.ASSET} />
                            }
                          />
                          <Route
                            path="/list"
                            element={
                              <ItemsList
                                NavType={LicenseTypes.ASSET}
                                setModalFlag={setModalFlag}
                                pageType={PageFor.GENERAL}
                              />
                            }
                          />
                          <Route
                            path="ob/list"
                            element={
                              <ItemOBList NavType={LicenseTypes.ASSET} />
                            }
                          />
                          <Route
                            path="individual/list"
                            element={
                              <ItemIndividualList
                                NavType={LicenseTypes.ASSET}
                              />
                            }
                          />
                        </Routes>
                      }
                    />
                  </Routes>
                }
              />
              <Route path="/calibration" element={<CalibrationDetails />} />
              <Route
                path="/:customerId/company/*"
                element={
                  <>
                    <Routes>
                      <Route path="/*" element={<CompanyRoutes />} />
                      <Route path="/" element={<CompanyDetails />} />
                      <Route path="/junctions" element={
                         <Junctions
                                        pageType={PageFor.GENERAL}
                                        setModalFlag={setModalFlag}
                                        pageForm={
                                          PageFromJunction.DASH_BOARD
                                        }
                                      />
                      } />
                      
                      <Route
                        path="/emailconfig"
                        element={
                          <EmailConfig
                            type={PageFor.GENERAL}
                            setModal={setModalFlag}
                          />
                        }
                      />
                    </Routes>
                  </>
                }
              />
              <Route
                path="/:customerId/company/:companyId/reports/assetsummary/:itemId"
                element={<ReportsIndex pageFrom={PageFrom.REPORTS} />}
              />
              <Route
                path="/:customerId/company/:companyId/reports/vendorwise/:supplier_id"
                element={<VendorWiseIndex />}
              />
              <Route
                path="/:customerId/company/:companyId/reports/signalwise"
                element={<SignalWiseIndex />}
              />
              <Route
                path="/:customerId/company/:companyId/reports/signalwise/:supplier_id"
                element={<SignalWiseIndex />}
              />
              <Route
                path="/:customerId/company/:companyId/reports/vendorwise/:itemId/itemdetails"
                element={<VendorWiseItemDetails />}
              />

              <Route
                path="/:customerId/company/:companyId/reports/ticketwise"
                element={<TicketWiseIndex queryType={TicketsQueryType.ALL} />}
              />
              <Route
                path="/:customerId/company/:companyId/reports/slawise"
                element={
                  <TicketWiseIndex queryType={TicketsQueryType.SLA_REPORT} />
                }
              />

              {/* <Route
              path="/userlogin/:customerId/company/"
              element={
                <>
                  <Routes>
                    <Route path="/*" element={<CompanyRoutes />} />
                    <Route path="/" element={<CompanyDetails />} />
                    <Route
                      path="/emailconfig"
                      element={
                        <EmailConfig
                          type={PageFor.GENERAL}
                          setModal={setModalFlag}
                        />
                      }
                    />
                  </Routes>
                </>
              }
            />
            <Route
              path="/userlogin/:customerId/subsidiary/*"
              element={<SubsidiaryRoutes />}
            />
            <Route
              path="/userlogin/:customerId/assetsite"
              element={
                <AssetSiteList
                  operation={Operation.CREATE}
                  setModalFlag={setModalFlag}
                />
              }
            />
            <Route
              path="/userlogin/:customerId/junctions/*"
              element={<JunctionRoutes />}
            /> */}
            </Routes>
          </DashBoard>
        </Router>
      )}
    </div>
  );
};

export default AssetRoutes;
